export default __webpack_public_path__ + "static/abbeyRoad-c65e9c162c8963f4da176f00f429049c.svg";